




import VueOptions from '@utils/VueOptions'
import BrandRepInvitationEdit from '@modules/website/components/Invitation/BrandRepInvitationEdit'

settings =
  name: 'BrandRepInvitationEditPage'
  vue: 
    components: { 'brand-rep-invitation-edit' : BrandRepInvitationEdit }

export default VueOptions.vue settings
